<script setup lang="ts">
import { twMerge } from 'tailwind-merge';

// PROPS
const props = defineProps({
    phone: { type: String, required: true },
    label: { type: String, default: undefined },
    class: { type: String, default: undefined },
    noTracking: { type: Boolean, default: false },
});

// EVENTS
const emit = defineEmits<{
    click: [];
}>();

// COMPOSABLES
const { trackPhoneLink } = useTracking();

// DATA
const mergedClass = twMerge('text-primary underline', props.class);

// METHODS
const onClick = (): void => {
    props.noTracking || trackPhoneLink(props.phone);
    emit('click');
};
</script>

<template>
    <a :href="`tel:${phone}`" :class="mergedClass" @click="onClick">
        <slot>{{ label ?? phone }}</slot>
    </a>
</template>
